<template>
    <div class='cover-konten'>
      <div class='container home'>
          <div class='box-home'>
              <h1>Bacalah Al Qur'an</h1>
              <p>
                  “Abu Umamah Al Bahily radhiyallahu ‘anhu berkata: “Aku telah mendengar 
                    Rasulullah shallallahu ‘alaihi wasallam bersabda: “Bacalah Al Quran karena 
                    sesungguhnya dia akan datang pada hari kiamat sebagai pemberi 
                    syafa’at kepada orang yang membacanya” (HR. Muslim)
              </p>
              <button class="btn-baca" @click="scrollDown()" type='button'>Ayo Kita Baca</button>
          </div>
          <div class='box-home' id='gambar-home'>
              <img src='../assets/gambar/quran.png' alt='Al Quran'/>
          </div>
      </div>

      <!-- list surat al quran -->

      <list-surah></list-surah>

      <!-- akhir list -->
    </div>
</template>
<style lang="css" scoped>
    .home 
    {
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .box-home 
    {
        width: 40%;
        height: auto;
    }
    .box-home h1{
        font-weight: 800;
        margin-bottom: 10%;
    }
    .box-home p 
    {
        font-size: 16px;
        line-height: 1.78;
    }
    #gambar-home 
    {
        width: 60%;
        text-align: center;
    }
    .btn-baca 
    {
        width: 50%;
        height: 45px;
        border: 1px solid#30e277;
        border-radius: 50px;
        margin-top: 10%;
        color: white;
        font-weight: bold;
        background-color:#30e277;
        transition: 0.5s;
    }
    .btn-baca:hover{
        box-shadow: 0px 6px 20px 1px #30e277;
    }
    .btn-baca:focus{
        outline: none;
        box-shadow: 0px 6px 30px 5px #30e277;
    }
    @media screen and (max-width: 780px)
    {
        .box-home
        {
            width: 100%;
        }
        #gambar-home 
        {
            display: none;
        }
    }

</style>
<script>
import List from './home/List.vue';
import axios from 'axios';

export default {
    components: {
        'list-surah': List,
    },
    data(){
        return {
            dir: 'Home',
        }
    },
    methods: {
        scrollDown(){
            scrollBy(0,700);
        }
    },
    created(){
        document.title = "AL - QUR'AN TERJEMAHAN BAHASA INDONESIA";
    }
}
</script>